// 別ページからのアンカーリンク移動
window.addEventListener('DOMContentLoaded', function() {
  const offset = 80; // 上部からの余白（px）
  const delay = 500; // 遅延時間（ミリ秒）

  // URLにハッシュが含まれているか確認
  if (window.location.hash) {
    // ハッシュを一時的に削除してデフォルトのスクロールを防ぐ
    const hash = window.location.hash;
    history.replaceState(null, null, ' ');

    const targetElement = document.querySelector(hash);
    if (targetElement) {
      // 一旦ページトップに移動
      window.scrollTo(0, 0);

      // 指定時間後にスクロール
      setTimeout(() => {
        const rect = targetElement.getBoundingClientRect();
        const scrollTop = window.scrollY + rect.top - offset;

        window.scrollTo({
          top: scrollTop,
          behavior: 'smooth'
        });

        // スクロール完了後にハッシュを復元
        history.replaceState(null, null, hash);
      }, delay);
    }
  }
});

// 同一ページ内でのアンカーリンクスクロール
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      const offset = 80; // 上部からの余白（px）
      const rect = targetElement.getBoundingClientRect();
      const scrollTop = window.scrollY + rect.top - offset;

      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });
    }
  });
});

